<template>
  <b-tabs v-model="activeTab" pills card>
    <SubProductTab :sub-products="product.sub_products" :product="product"/>
    <SupplierProductTab :supplier-products="product.supplier_products" :product="product"/>
    <!--<StoreProductTab :store-products="product.store_products" :product="product"/>-->
    <TyProductTab :product="product" :ty-products="product.ty_product_all"/>
  </b-tabs>
</template>
<script>
import SupplierProductTab from "@/views/v2/products/Tabs/SupplierProductTab.vue";
import StoreProductTab from "@/views/v2/products/Tabs/StoreProductTab.vue";
import SubProductTab from "@/views/v2/products/Tabs/SubProductTab.vue";
import TyProductTab from "@/views/v2/products/Tabs/TyProductTab.vue";

export default {
  name: "ProductDetail",
  components: {SupplierProductTab, StoreProductTab, SubProductTab, TyProductTab},
  data: () => ({
    activeTab: 0
  }),
  props: {
    product: {
      type: Object,
      required: true
    }
  }
}
</script>

<style scoped>
.card-header {
  padding: 0px;
}

.nav-pills {
  margin: 0px;
}

.card-body {
  padding: 0rem 1.5rem;
}
</style>